<template>
    <div class="md-layout md-gutter">
        <div class="md-layout-item md-size-100">

            <div class="intervention-details__card">
                <p class="font-medium mb-2 text-sm">
                    Détails de l'intervention
                    <span class="text-info">{{ '#' + $route.params.interventionId }}</span>
                </p>
                <md-divider class="mb-1 -mt-1 -mx-2"></md-divider>
	            <div class="text-sm">
	                <p class="leading-none text-info font-bold mb-1 text-base">{{ intervention.site.name }}</p>
	                <div class="leading-4 mb-1">
	                    <span class="font-medium">Type :</span>
	                    <span class="ml-1">{{ intervention.intervention_type.name }}</span>
	                </div>
	                <div class="leading-4 mb-1">
	                    <span class="font-medium">Contexte :</span>
	                    <span class="ml-1">{{ intervention.category.name }}</span>
	                </div>
	                <div class="leading-4 mb-1">
	                    <span class="font-medium">Date :</span>
	                    <span class="ml-1">{{ date }}</span>
	                </div>
	                <div class="leading-4 mb-0.5">
	                    <span class="font-medium">Commentaire :</span>
	                    <span class="ml-1">{{ intervention.comment ? intervention.comment : 'Ø' }}</span>
	                </div>
	            </div>
            </div>

            <div class="intervention-details__card mt-2">
                <p class="font-medium mb-2 text-sm">Détails du site</p>
                <md-divider class="mb-1.5 -mt-1 -mx-2"></md-divider>
                <div class="text-sm">
	                <div class="leading-4 mb-1">
		                <span class="font-medium">Addresse :</span>
		                <span class="ml-1">{{ address }}</span>
	                </div>
	                <div class="leading-none mb-1">
		                <div class="flex items-center space-x-2">
			                <span class="font-medium">Géolocalisation :</span>
			                <div class="flex items-center space-x-2" v-if="hasGeolocation">
				                <md-button class="md-icon-button md-small-icon my-0 px-2 md-primary"
				                           @click="goToMap('google')">
					                <font-awesome-icon class="md-icon" :icon="['fa', 'map-marker-alt']" />
					                <span class="leading-none font-medium ml-1.5">Google Maps</span>
				                </md-button>
				                <md-button class="md-icon-button md-small-icon my-0 px-2 md-waze"
				                           @click="goToMap('waze')">
					                <font-awesome-icon class="md-icon" :icon="['fab', 'waze']" />
					                <span class="leading-none font-medium ml-1.5">Waze</span>
				                </md-button>
			                </div>
			                <span v-else class="ml-1">Indisponible</span>
		                </div>
	                </div>
	                <div class="leading-4 mb-2">
		                <span class="font-medium">Contacts RDV :</span>
		                <template v-if="intervention.site.contacts.length > 0">
			                <div v-for="(contact, index) in intervention.site.contacts" :key="contact.id" class=" mt-0.5">
				                <span class="w-auto">{{ `${contact.full_name} | ${contact.role}` }}</span>
				                <div class="flex items-center justify-between">
					                <div class="flex items-center space-x-1">
						                <span class="font-medium">T :</span>
						                <a v-if="contact.phone" :href="`tel:${contact.phone}`" class="min-w-max text-info cursor-pointer">{{ contact.phone }}</a>
						                <span v-else>Ø</span>
					                </div>
					                <div class="flex items-center space-x-1">
						                <span class="font-medium">M :</span>
						                <a v-if="contact.mobile" :href="`tel:${contact.mobile}`" class="min-w-max text-info cursor-pointer">{{ contact.mobile }}</a>
						                <span v-else>Ø</span>
					                </div>
				                </div>
				                <md-divider v-if="(index + 1) < intervention.site.contacts.length" class="my-1.5"></md-divider>
			                </div>
		                </template>
		                <span class="ml-1" v-else>Ø</span>
	                </div>
	                <div class="leading-none cursor-pointer flex items-center justify-between"
	                     @click="showInfos = !showInfos">
		                <span class="font-medium">Voir les informations complémentaires</span>
		                <font-awesome-icon class="md-icon icon-show-info" :icon="['fa', showInfos ? 'minus' : 'plus']" />
	                </div>
	                <template v-if="showInfos">
		                <div class="leading-4 mb-1">
			                <span class="font-medium">Site :</span>
			                <span class="ml-1">{{ intervention.site.note ? intervention.site.note : 'Ø' }}</span>
		                </div>
	                </template>
                </div>
            </div>

            <div class="intervention-details__card mt-2">
                <p class="font-medium mb-2 text-sm">Horaires du site</p>
                <md-divider class="mb-1.5 -mt-1 -mx-2"></md-divider>
                <div class="text-sm">
	                <template v-if="intervention.site.schedules.length > 0">
		                <div class="leading-none mb-1">
			                <md-list id="schedules" class="mt-0.5">
				                <md-list-item v-for="schedule in intervention.site.schedules" :key="schedule.id">
                                <span class="md-list-item-text text-sm">
                                    <div class="flex items-center">
                                        <span class="font-medium">{{ dayOfWeek(schedule.day_number) + ' : ' }}</span>
                                        <div class="flex items-center divide-x-2 divide-gray-300">
                                            <span class="px-1 pr-1.5" v-for="subSchedule in schedule.schedules" :key="subSchedule.id">
                                                {{ subSchedule.start + ' à ' + subSchedule.end }}
                                            </span>
                                        </div>
                                    </div>
                                </span>
				                </md-list-item>
			                </md-list>
		                </div>
		                <md-divider class="mb-1 -mx-2"></md-divider>
	                </template>
	                <div class="leading-4 text-sm">
		                <span class="font-medium">Informations horaires :</span>
		                <span class="ml-1 text-black font-normal">{{ intervention.site.schedule_comment ? intervention.site.schedule_comment : 'Ø' }}</span>
	                </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import dateTimeFormattingMixin from '@/mixins/date-time-formatting-mixin'
export default {
    name: "InterventionInformations",
    mixins: [dateTimeFormattingMixin],
    props: {
        intervention: Object
    },
    data() {
        return {
            showInfos: false
        }
    },
    computed: {
        date() {
            const start = this.$moment(this.intervention.planningable.start_date)
            const end = this.$moment(this.intervention.planningable.end_date)
            return `Le ${start.format('DD/MM/YYYY')} de ${start.format('HH:mm')} à ${end.format('HH:mm')}`
        },
        address() {
            const siteAddress = this.intervention.site.address
            return `${siteAddress.addresses}, ${siteAddress.city} ${siteAddress.zip_code}`
        },
        hasGeolocation() {
            return !!(this.intervention.site.address.geo_lat && this.intervention.site.address.geo_long)
        }
    },
    methods: {
        goToMap(type) {
            let url = ''
            if (type === 'waze') {
                url = `https://www.waze.com/ul?ll=${this.intervention.site.address.geo_lat}%2C${this.intervention.site.address.geo_long}&navigate=yes&zoom=17`
            } else {
                url = `https://www.google.fr/maps/place/${this.intervention.site.address.geo_lat},${this.intervention.site.address.geo_long}`
            }
            window.open(url, '_blank')
        },
    }
}
</script>

<style scoped lang="scss">
#schedules.md-list {
    padding: 0;
    .md-list-item {
        margin-bottom: .15rem;
        margin-left: 0;

        ::v-deep {
            .md-list-item-content {
                padding: 0 !important;
                min-height: 15px !important;
            }
        }

        .md-list-item-content {
            padding: 0 !important;

            .md-list-item-text * {
                color: $black-color;
            }

            * {
                width: unset;
            }
        }
    }
}
</style>
